import { render, staticRenderFns } from "./editchange.vue?vue&type=template&id=29b19a4c&scoped=true&"
import script from "./editchange.vue?vue&type=script&lang=js&"
export * from "./editchange.vue?vue&type=script&lang=js&"
import style0 from "./editchange.vue?vue&type=style&index=0&id=29b19a4c&lang=less&scoped=true&"
import style1 from "./editchange.vue?vue&type=style&index=1&id=29b19a4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b19a4c",
  null
  
)

export default component.exports